import { render } from "./TutorialPopup.vue?vue&type=template&id=636cd302&scoped=true"
import script from "./TutorialPopup.vue?vue&type=script&lang=js"
export * from "./TutorialPopup.vue?vue&type=script&lang=js"

import "./TutorialPopup.vue?vue&type=style&index=0&id=636cd302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636cd302"]])

export default __exports__